import React, {FC} from "react";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb} from "antd";
import DtoTable from "../../components/dto-table/dto-table";
import MscStockMovementModel from "../../models/mscstockmovements/msc-stock-movement-model";

const MscStockMovementsScreen: FC = () => {

    const [trigger, setTrigger] = useSafeState(false);

    return (
        <>
            <Breadcrumb style={{marginBottom: 10}}>
                <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'MSC Stock Movements'}></Trans></Breadcrumb.Item>
            </Breadcrumb>
            
            <DtoTable
                model={MscStockMovementModel}
                trigger={trigger}
                allowRefreshButton={true}
                pageSize={100}
                scroll={{x: 1800, y: "65vh"}}
            />
        </>
    )
}

export default MscStockMovementsScreen;
